const base = {
  fontFamily: "textSans",
  fontWeight: 400,
  fontSize: "fs12",
  boxShadow: "lg",
  width: 275,
  lineHeight: "lh400",
  textAlign: "center",
  p: "s600",
  zIndex: 29,
};

export const tooltip = {
  "> div": {
    ...base,
    bg: "grey700",
    color: "white",
  },
  "> div > div": {
    color: "grey700",
    "> svg > path": {
      fill: "grey700",
    },
  },
};

export const tooltipDark = {
  "> div": {
    ...base,
    bg: "grey100",
    color: "grey700",
  },
  "> div > div": {
    color: "grey100",
    "> svg > path": {
      fill: "grey100",
    },
  },
};

export const tooltipPrimary = {
  ...tooltip,
};

export const tooltipPrimaryDark = {
  ...tooltipDark,
};

export const tooltipVideoPlayer = {
  ...tooltip,
  zIndex: 10000,
  mr: "s300",
  svg: {
    width: "iconSizeBase",
    height: "auto",
  },
  "> div": {
    ...base,
    bg: "grey700",
    color: "white",
    p: "s300",
    width: 100,
    fontSize: "fs10",
  },
};
